__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "AustinEhsHoursWorked";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amzn/austin-core", "2.142.0", () => (Promise.all([__webpack_require__.e(8179), __webpack_require__.e(4770), __webpack_require__.e(2036), __webpack_require__.e(8175), __webpack_require__.e(922), __webpack_require__.e(8727), __webpack_require__.e(9371), __webpack_require__.e(7118), __webpack_require__.e(2318)]).then(() => (() => (__webpack_require__("../node_modules/@amzn/austin-core/dist/index.js"))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(8325), __webpack_require__.e(3232)]).then(() => (() => (__webpack_require__("../node_modules/react-dom/index.js"))))));
			register("react-router-6", "6.30.1", () => (Promise.all([__webpack_require__.e(744), __webpack_require__.e(7435), __webpack_require__.e(8175)]).then(() => (() => (__webpack_require__("../node_modules/react-router/dist/index.js"))))));
			register("react-router-dom", "6.30.1", () => (Promise.all([__webpack_require__.e(744), __webpack_require__.e(9348), __webpack_require__.e(8175), __webpack_require__.e(6670)]).then(() => (() => (__webpack_require__("../node_modules/react-router-dom/dist/index.js"))))));
			register("react", "18.2.0", () => (__webpack_require__.e(3696).then(() => (() => (__webpack_require__("../node_modules/react/index.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};